import React from "react";
import { Box } from "@mui/material";
import { MyTimesheetCalendarTooltip } from "my-timesheet/components";
import { MyTimesheetStyledCalendarTooltip } from "my-timesheet/components";

interface MyTimesheetCalendarEventWrapperProps {
  event: any; // Replace 'any' with the specific type of 'event' if known
  children: React.ReactNode;
}

export const MyTimesheetCalendarEventWrapper = (
  props: MyTimesheetCalendarEventWrapperProps,
) => {
  const { event, children } = props;
  return (
    <MyTimesheetStyledCalendarTooltip
      title={<MyTimesheetCalendarTooltip event={event} />}
    >
      <Box>{children}</Box>
    </MyTimesheetStyledCalendarTooltip>
  );
};

export default MyTimesheetCalendarEventWrapper;
